import React from 'react';
import RatingUtils from 'src/components/rating/rating-helper';
import Rating from 'src/components/rating';

// TODO Add equivalent icon to DS and use here
import StarIcon from 'mdi-react/StarIcon';

import * as S from './styles';

type Props = {
  className?: string;
  grade: number;
  text?: string;
  as?: 'stars' | 'badge';
};

function ExpertRating({ className, grade, text, as = 'badge' }: Props) {
  const rating = RatingUtils.toRoundedString(grade);

  if (as === 'stars') {
    return (
      <S.Stars className={className}>
        <Rating rate={grade} expertColors size="large" />{' '}
        <S.RatingText>{rating}</S.RatingText>
      </S.Stars>
    );
  }

  return (
    <S.ExpertRating className={className}>
      {text && <S.Text>{text}: </S.Text>}
      <S.Badge>
        <StarIcon size={16} />
        {rating}
      </S.Badge>
    </S.ExpertRating>
  );
}

export default ExpertRating;
